// Host-scoped room mutations for the Studio dashboard archive. Both run under
// RLS as the signed-in user: rename uses rooms_update_host, delete uses
// rooms_delete_host (own-row only; room_cohosts cascades).

import { supabase } from '@/lib/supabase';

export async function renameRoom(roomId: string, title: string): Promise<void> {
  const { error } = await supabase.from('rooms').update({ title }).eq('id', roomId);
  if (error) throw error;
}

export async function deleteRoom(roomId: string): Promise<void> {
  const { error } = await supabase.from('rooms').delete().eq('id', roomId);
  if (error) throw error;
}
